import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import Layout from '../components/Layout';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import { ReserveSplitBuilding } from '../components/ReserveSplitBuilding';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ReserveSplitFix() {
  const { language: lang } = useLanguage();
  const L = (el, en) => (lang === 'el' ? el : en);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const load = useCallback(async () => {
    setLoading(true);
    try { setData((await axios.get(`${API}/reserve-split-fix/dry-run`)).data); }
    catch (e) { toast.error(e.response?.data?.detail || 'Error'); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-4 py-6" data-testid="reserve-split-fix-page">
        <h1 className="text-xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>{L('Διόρθωση κατανομής Κοινοχρήστων / Αποθεματικού', 'Monthly Fee / Reserve Fund split correction')}</h1>
        <p className="text-sm text-zinc-600 mt-1 max-w-3xl">{L(
          'Έλεγχος (χωρίς αλλαγές) των υπαρχόντων τιμολογίων κοινοχρήστων: όπου το σύνολο περιλαμβάνει ήδη το Έκτακτο Αποθεματικό αλλά καταχωρήθηκε ως μία γραμμή, προτείνεται διαχωρισμός με βάση τις αποθηκευμένες ρυθμίσεις (Ετήσια Έξοδα / μηνιαία συνεισφορά και Έκτακτο Αποθεματικό). Το σύνολο, ο αριθμός, η ημερομηνία, οι πληρωμές και οι αποδείξεις δεν αλλάζουν. Όσα δεν ταιριάζουν με τις ρυθμίσεις επισημαίνονται για έλεγχο και δεν αλλάζουν.',
          'Dry-run of existing common-expense invoices: where the total already includes the Extra Reserve but was booked as one line, a split is proposed from the saved settings. Totals, numbers, dates, payments and receipts never change. Records that do not match the settings are flagged for review and left untouched.')}</p>
        <Button onClick={load} disabled={loading} variant="outline" className="rounded-none mt-3" data-testid="rsf-refresh">{loading ? '…' : L('Νέος έλεγχος (dry-run)', 'Run dry-run again')}</Button>
        <div className="space-y-6 mt-6">
          {data && !data.buildings.length && <p className="text-sm text-emerald-700" data-testid="rsf-nothing">{L('Δεν βρέθηκαν τιμολόγια προς διόρθωση.', 'No invoices need correction.')}</p>}
          {data?.buildings.map((b) => <ReserveSplitBuilding key={`${b.building_id}-${b.to_correct}`} b={b} lang={lang} onApplied={load} />)}
        </div>
        {data?.history?.length > 0 && (
          <div className="mt-8 text-xs" data-testid="rsf-history">
            <div className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">{L('Ιστορικό διορθώσεων', 'Correction history')}</div>
            {data.history.map((h) => <div key={h.fix_id} className="py-0.5">{new Date(h.at).toLocaleString('el-GR')} · {h.building_name || h.building_id} · {h.count} {L('τιμολόγια', 'invoices')} · €{Number(h.reserve_total || 0).toFixed(2)} · {h.by} · {h.fix_id}</div>)}
          </div>)}
      </div>
    </Layout>
  );
}
